import ResponsiveStyleSheet from "react-native-media-query";
import { createResponsiveStyles, theme } from "@clearabee/ui-library-native";
import { PANEL_HEIGHT } from "lib/styles/constants";

export const { styles, ids } = ResponsiveStyleSheet.create({
  panel: createResponsiveStyles({
    base: {
      overflow: "visible",
    },
    large: {
      height: PANEL_HEIGHT,
      justifyContent: "flex-start",
    },
  }),
  productDetails: createResponsiveStyles({
    base: {
      alignItems: "center",
    },
    small: {
      flex: 1,
      alignItems: "flex-start",
    },
  }),
  priceContainer: createResponsiveStyles({
    base: {
      marginTop: theme.spacing.xsmall,
      alignItems: "center",
    },
    small: {
      alignItems: "baseline",
    },
  }),
  priceInnerContainer: {
    flexDirection: "row",
    alignItems: "baseline",
  },
  imageContainer: createResponsiveStyles({
    base: {
      width: 200,
      height: 200,
      alignSelf: "center",
    },
    small: {
      display: "flex",
      flex: 1,
      width: "100%",
    },
  }),

  image: {
    display: "flex",
    flex: 1,
  },
  productTitle: createResponsiveStyles({
    base: {
      marginBottom: theme.spacing.xsmall,
      textAlign: "center",
      fontFamily: "ProximaBold",
    },
    small: {
      textAlign: "left",
    },
  }),
  productDescription: createResponsiveStyles({
    base: {
      textAlign: "center",
    },
    small: {
      maxWidth: 340,
      textAlign: "left",
    },
  }),
  calloutChargePanel: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
    paddingVertical: theme.spacing.xsmall2,
    paddingHorizontal: theme.spacing.xsmall,
    minWidth: 215,
  },
  imagePanelWrapper: createResponsiveStyles({
    base: {
      marginTop: theme.spacing.small,
      alignItems: "center",
    },
    small: {
      alignItems: "flex-start",
    },
  }),
  photoExplanation: createResponsiveStyles({
    base: {
      marginTop: theme.spacing.xsmall,
      textAlign: "center",
      ...theme.fontDefaults.xsmall,
    },
    small: {
      textAlign: "left",
      maxWidth: 240,
    },
  }),
});
